export const ENDPOINTS = {
  WORKSPACES: '/workspaces',
  RUNNABLES: '/runnables',
  WORKFLOWS: '/workflows',
  EXECUTOR_POOLS: '/executorPools',
  ACTIVE_EXECUTIONS: '/activeExecutions',
};
